import { render, staticRenderFns } from "./FeedPin.vue?vue&type=template&id=a0697354&"
import script from "./FeedPin.vue?vue&type=script&lang=js&"
export * from "./FeedPin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports